import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TableModule, TableLazyLoadEvent } from "primeng/table";
import { DialogModule } from 'primeng/dialog';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { AdminPageHeaderComponent } from '../shared/admin-page-header/admin-page-header.component';
import { AnnouncementFormComponent } from './announcement-form/announcement-form.component';

import { AnnouncementService } from '../../services/announcement.service';
import { Announcement } from '../../models/announcement';

@Component({
  selector: 'app-announcements',
  imports: [
    AdminPageHeaderComponent,
    AnnouncementFormComponent,
    TableModule,
    CommonModule,
    DialogModule,
    ToastModule
  ],
  providers: [MessageService],
  templateUrl: './announcements.component.html',
  styleUrl: './announcements.component.scss'
})
export class AnnouncementsComponent {
  readonly title = 'Anúncios';
  readonly subtitle = 'Crie e gerencie os anúncios exibidos na plataforma.';

  errorMessage: string | null = null;

  isLoadingAnnouncements = false;
  announcements: Announcement[] = [];
  totalAnnouncements = 0;
  page = 1;
  rowsPerPage = 10;

  displayCreateAnnouncementModal = false;
  deactivatingId: number | null = null;

  constructor(
    private announcementService: AnnouncementService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.fetchAnnouncements();
  }

  fetchAnnouncements(): void {
    this.isLoadingAnnouncements = true;

    this.announcementService.listAnnouncements(this.page).subscribe({
      next: (response) => {
        this.announcements = response.results;
        this.totalAnnouncements = response.count;
        this.isLoadingAnnouncements = false;
      },
      error: (error) => {
        this.errorMessage = 'Erro ao carregar anúncios.';
        console.error('Error fetching announcements:', error);
        this.isLoadingAnnouncements = false;
      }
    })
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    const first = event.first ?? 0;
    this.page = Math.floor(first / this.rowsPerPage) + 1;
    this.fetchAnnouncements();
  }

  openCreateAnnouncementDialog() {
    this.displayCreateAnnouncementModal = true;
  }

  createAnnouncementSuccess() {
    this.displayCreateAnnouncementModal = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: 'Anúncio criado com sucesso!'
    });
    this.fetchAnnouncements();
  }

  deactivateAnnouncement(announcement: Announcement): void {
    this.deactivatingId = announcement.id;

    this.announcementService.deactivateAnnouncement(announcement.id).subscribe({
      next: () => {
        this.deactivatingId = null;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Anúncio desativado com sucesso!'
        });
        this.fetchAnnouncements();
      },
      error: (error) => {
        this.deactivatingId = null;
        console.error('Error deactivating announcement:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível desativar o anúncio.'
        });
      }
    });
  }
}
